import { motion } from 'framer-motion';

export default function BlogHero() {
  return (
    <section className="relative pt-40 pb-16 px-6 overflow-hidden">
      <div className="max-w-5xl mx-auto text-center relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <span className="text-xs font-inter font-medium tracking-[0.3em] uppercase text-primary mb-4 block">
            Insights &amp; Updates
          </span>
          <h1 className="font-inter font-black text-5xl md:text-7xl tracking-[-0.03em] text-foreground mb-6 leading-[1.05]">
            Insights on AI, Software & Cybersecurity
          </h1>
          <p className="text-lg text-muted-foreground font-inter leading-relaxed max-w-2xl mx-auto">
            Deep dives on AI agents, custom software, cybersecurity, mobile engineering, and the milestones
            shaping our ecosystem of ventures.
          </p>
        </motion.div>
      </div>
    </section>
  );
}